import { render, staticRenderFns } from "./ESituacaoPlanoBimestralInfantil.vue?vue&type=template&id=0403a89e"
import script from "./ESituacaoPlanoBimestralInfantil.vue?vue&type=script&lang=js"
export * from "./ESituacaoPlanoBimestralInfantil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports